/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import PageWrapper from '../../../../../modules/PageWrapper';
import {observer} from 'mobx-react';
import Filters from '../../../../../table/new/filters/Filters';
import Presets from '../../../../../table/new/Presets';
import {getFilters} from './getFilters';
import {facebookStatisticsFilters} from './filtersConfigs';
import {facebookStatisticsGroups} from './groupsConfigs';
import TableWrapper from '../../../../../table/new/TableWrapper';
import Columns from '../../../../../table/new/Columns';
import {baseFields} from '../../../../../table/new/customizationTable';
import BlankSheet from '../../../../../table/new/BlankSheet';
import FullScreen from '../../../../../table/new/FullScreen';
import Refresh from '../../../../../table/new/Refresh';
import ResultsCount from '../../../../../table/new/ResultsCount';
import AddTraffic from './AddTraffic';
import Search from '../../../../../table/new/SearchForTable';

const Companies = () => {
  const [prevTimeConfig, setPrevTimeConfig] = useState(null);
  const [editItemId, setEditItemId] = useState(null);

  return (
    <PageWrapper
      firstTimeConfig='current_month'
      prevTimeConfig={prevTimeConfig}
      breadcrumbs={[
        {title: 'Трекер'},
        {isSeparator: true},
        {title: 'Facebook'},
        {isSeparator: true},
        {title: 'Кампании', path: '/tracker/facebook/companies', isActive: true},
      ]}
      title={'Кампании'}
    >
      <TableWrapper
        setPrevTimeConfig={setPrevTimeConfig}
        prevTimeConfig={prevTimeConfig}
        getMethod={'Dashboard/Facebook/getCampaignStatistic'}
        getFilters={getFilters}
        setEditItemId={setEditItemId}
        edit={null}
        defaultFilters={[
          {
            filter: 'state',
            isFixed: true,
            options: [
              'recently_created',
              'with_data',
            ],
          },
          {filter: 'bayer_id', isFixed: true, options: []},
          {filter: 'offer_id', isFixed: true, options: []},
          {filter: 'link_id', isFixed: true, options: []},
        ]}
        defaultGroups={[
          {group: 'traffic', isFixed: true},
          {group: 'source', isFixed: true},
          {group: 'campaign', isFixed: true},
          {group: 'adset', isFixed: true},
          {group: 'ad', isFixed: true},
        ]}
        //на випадок якщо нам взагалі не потрібно показувати вибір груп
        hasHiddenGroups={true}
        baseFields={baseFields}
        disabledByDefault={[
          'click2reg',
          'click2cpa',
          'lead2fd',
          'lead2cpa',
          'chat2reg',
          'reg2cpa',
          'fd2cpa',
          'reg2rs',
          'chat2rs',
          'lead2rs',
          'click2rs',
        ]}
      >
        <Filters
          facebookStatisticsFilters={facebookStatisticsFilters}
          facebookStatisticsGroups={facebookStatisticsGroups}
          childrenNearGroups={
            <>
              <AddTraffic type={'facebook'} />
              <Search />
            </>
          }
          childrenPresets={
            <>
              <ResultsCount />
              <BlankSheet />
              <Columns columns={baseFields} />
              <Presets />
              <FullScreen />
            </>
          }
          childrenHead={false}
          childrenRefresh={false}
          childrenByFilters={<Refresh />}
        />
      </TableWrapper>
    </PageWrapper>
  );
};

export default observer(Companies);
